import type { IWorkJourneyManagementAttentionItem } from '@src/models/interfaces/workJourneyManagement.interface';

type FormatMessage = (
  descriptor: { id: string },
  values?: Record<string, string | number>,
) => string;

/**
 * Human-readable description for an attention / day-conflict row.
 */
export const getAttentionDescription = (
  item: IWorkJourneyManagementAttentionItem,
  formatMessage: FormatMessage,
): string => {
  const { details, requiredMembers, assignedMembers } = item;
  const required = details.requiredMembers ?? requiredMembers;

  switch (item.state) {
    case 'understaffed_due_to_absences': {
      const presentWorkers = details.presentWorkers ?? 0;
      const missing = Math.max(required - presentWorkers, 0);
      return formatMessage(
        { id: 'workJourney.management.description.understaffed_due_to_absences' },
        { presentWorkers, requiredMembers: required, missing },
      );
    }
    case 'users_unavailable': {
      const count = details.unavailableUsers?.length ?? 0;
      return formatMessage(
        { id: 'workJourney.management.description.users_unavailable' },
        { count },
      );
    }
    case 'rejected_shift_change': {
      const rejectedCount = details.rejectedShiftChanges?.length ?? 0;
      return formatMessage(
        { id: 'workJourney.management.description.rejected_shift_change' },
        { count: rejectedCount },
      );
    }
    case 'insufficient_assigned_members': {
      const assigned = details.assignedMembers ?? assignedMembers;
      const missing = Math.max(required - assigned, 0);
      return formatMessage(
        { id: 'workJourney.management.description.insufficient_assigned_members' },
        { assignedMembers: assigned, requiredMembers: required, missing },
      );
    }
    default:
      return '';
  }
};
